import axios from 'axios';
import { loginreq, req } from './axiosFun';
import {getStore} from "../utils/util";

var qz="";
export const login = (params) => {
  return axios.post(qz+"/api/BKUser/Login",params)
    .then(res => res.data) };


// 获取用户菜单
export const userList = (params) => {
  return axios.get(qz+"/api/BKUser/GetUserList?&account="+params.account
    +"&pageIndex=" +params.pageIndex+"&pageSize=" + params.pageSize,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };


export const addUser = (params) => {
  return axios.post(qz+"/api/BKUser/AddUser",params,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const delUser = (params) => {
  return axios.post(qz+"/api/BKUser/DeleteUser?id="+params.id,null,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const userInfo = (params) => {
  return axios.get(qz+"/api/BKUser/GetUserById?id="+params.id,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const resetPwd = (params) => {
  return axios.post(qz+"/api/BKUser/ResetPwd?id="+params.id,null,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const deleteUserCj = (params) => {
  return axios.post(qz+"/api/BKUser/DeleteUserCj?phone="+params.phone,null,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const addUserCj = (params) => {
  return axios.post(qz+"/api/BKUser/AddUserCj?sn="+params.sn,null,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const updatePwd = (params) => {
  return axios.post(qz+"/api/BKUser/UpdatePwd?id="+params.id+"&pwd1="+params.pwd1+"&pwd2="+params.pwd2,null,{
    headers:{
      'Authorization': `Bearer ${getStore("token")}`
    }
  }).then(res => res.data) };

export const updatePwd2 = (params) => {
  return axios.post(qz+"/api/BKUser/UpdatePwd2?id="+params.id+"&pwd="+params.pwd,null,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  }).then(res => res.data) };

export const addUserPlat = (params) => {
  return axios.post(qz+"/api/BKUser/AddUserPlat?lx="+params.lx+"&platno="+params.platno,null,{
    headers:{
      'Authorization': `Bearer ${getStore("token")}`
    }
  }).then(res => res.data) };

export const getUserPlat = () => {
  return axios.get(qz+"/api/BKUser/GetUserPlat",{
    headers:{
      'Authorization': `Bearer ${getStore("token")}`
    }
  })
    .then(res => res.data) };



// WEBPACK FOOTER //
// ./src/api/bkUser.js